module.exports = __webpack_public_path__ + "img/trouble-3.e587c46f.png";